<template>
    <div v-if="info" id="result">
        <b-img :src="info.Character.Portrait" rounded ></b-img>
        <div style="color:#ddd">
            <h1>{{ info.Character.Name }}</h1>
            <h3>Data Center {{ info.Character.DC }} | Server {{ info.Character.Server }}</h3>
            <h4>Level {{ info.Character.ActiveClassJob.Level }} {{ info.Character.ActiveClassJob.UnlockedState.Name }}</h4>
            <p>{{ info.Character.ActiveClassJob.ExpLevel }} / {{ info.Character.ActiveClassJob.ExpLevelMax }}</p>
        </div>
    </div>
    <div v-else-if="search && search.Pagination.ResultsTotal>1" id="carousel">
        <div>
            <b-carousel v-model="slide" :interval="0" controls indicators img-width="2048" img-height="720" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
                <b-carousel-slide img-blank v-for="(index, j) in Math.ceil(search.Pagination.Results / 8)" :key="j">
                    <div class="card-deck">
                        <div class="col-md-3" style="float:left" v-for="(index, i) in 8" :key="i">
                            <div class="card mb-2" v-if=" j * 8 + i < search.Pagination.Results">
                                <b-img class="card-img-top" :src="search.Results[j * 8 + i].Avatar" rounded alt="Card image cap"></b-img>
                                <div class="card-body">
                                    <h4 class="card-title">{{ search.Results[j * 8 + i].Name }}</h4>
                                    <p class="card-text">|{{ search.Results[j * 8 + i].Lang }}| {{ search.Results[j * 8 + i].Server }}</p>
                                    <b-button size="md" block variant="dark" @click="id = search.Results[j * 8 + i].ID">Choose</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-carousel-slide>
            </b-carousel>
        </div>
    </div>
    <div v-else id="logo">
        <img src="@/assets/logo-ffxiv.png"/>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: "PlayerVue",
    props: ["url"],
    data() {
        return {
            searchUrl : this.url,
            playerUrl : "",
            defaultUrl : "https://xivapi.com/character/",
            search: null,
            id: null,
            info: null,
            slide: 0,
            sliding: null,
        }
    },
    methods: {
        updateUrl: function (url) {
            this.searchUrl = url
        },
        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        }
    },
    watch: {
        url: function() {
            this.searchUrl = this.url
        },
        searchUrl: function () {
            axios.get(this.searchUrl)
                .then(res => {
                    console.log(res)
                    if (res.data.Pagination.ResultsTotal == 0) {
                        alert("\n\nPlayer not found. Please try again.");
                    }
                    else if (res.data.Pagination.ResultsTotal == 1) {
                        this.id = res.data.Results[0].ID;
                    }
                    else {
                        this.search = res.data;
                        this.info = null;
                    }
                })
                .catch(err => {
                    this.result = "none"
                    console.log(err)
                })
        },
        id: function () {
            this.playerUrl = this.playerUrl.concat(this.defaultUrl, this.id);
            axios.get(this.playerUrl)
                .then(res => {
                    this.info =  res.data;
                    console.log(res);
                })
                .catch(err => {
                    this.result = "none"
                    console.log(err)
                })
                this.playerUrl = "";
                this.search = null;
        }
    }
}
</script>

<style scoped>

#result {
    height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
    /* opacity: 0.7;
    background-color:  rgb(92, 6, 6); */
}

#carousel {
    height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: rgba(95, 158, 160, 0.527); */
}

.card {
    background-color: rgb(19, 21, 22);
}

#logo {
    height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.3;
}

.test {
    height: 85vh;
    width: 95vh;
    background-color:  rgb(92, 6, 6);
}

img {
    max-height: 100%;
    max-width: 100%;
    vertical-align: middle;
}

.card-img-top {
    width: 6vw;
    height: 6vw;
    margin-left: auto;
    margin-right: auto;
}

</style>